import type { ModelType } from "@/types";
import { MODEL_TYPE_OPTIONS } from "./modelCapabilities";

export interface ModelTypeSelectProps {
  idPrefix: string;
  value: ModelType;
  onChange: (value: ModelType) => void;
}

/** The "Model Type" dropdown (chat / embedding / image / audio / research). */
export function ModelTypeSelect({ idPrefix, value, onChange }: Readonly<ModelTypeSelectProps>) {
  return (
    <div>
      <label htmlFor={`${idPrefix}-type`} className="block text-sm font-medium text-content-secondary mb-1.5">
        Model Type
      </label>
      <select
        id={`${idPrefix}-type`}
        value={value}
        onChange={(e) => onChange(e.target.value as ModelType)}
        className="w-full px-3 py-2 bg-surface-secondary border border-border-secondary rounded-lg text-content-primary focus:outline-hidden focus:ring-2 focus:ring-brand-primary/50"
      >
        {MODEL_TYPE_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
